import { categoryNav, siteName } from "@/mocks/chigua";

interface FooterProps {
  onPickCategory: (id: string) => void;
}

const pageLinks = [
  { id: "feed", label: "最新资讯" },
  { id: "hot", label: "全网热搜" },
  { id: "dive", label: "本期深扒" },
  { id: "faq", label: "常见问题" },
  { id: "about", label: "关于本站" },
];

export default function Footer({ onPickCategory }: FooterProps) {
  return (
    <footer className="mt-16 bg-secondary-100 text-secondary-950">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          {/* 品牌 */}
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-newspaper-fill"></i>
              </span>
              <span className="font-heading text-xl font-black">{siteName}</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-secondary-800">
              专注娱乐与热门话题的资讯平台，第一时间带来最新独家猛料与深度深扒，内幕不设限，吃瓜就要吃最新最猛的。
            </p>
          </div>

          {/* 栏目 */}
          <div>
            <h4 className="font-heading text-base font-bold text-secondary-950">内容栏目</h4>
            <ul className="mt-4 space-y-2.5">
              {categoryNav.map((c) => (
                <li key={c.id}>
                  <button
                    type="button"
                    onClick={() => onPickCategory(c.id)}
                    className="inline-flex items-center gap-2 text-sm text-secondary-800 transition hover:text-primary-700"
                  >
                    <i className={`${c.icon} text-base text-secondary-600`}></i>
                    {c.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* 页内导航 */}
          <div>
            <h4 className="font-heading text-base font-bold text-secondary-950">快速直达</h4>
            <ul className="mt-4 space-y-2.5">
              {pageLinks.map((l) => (
                <li key={l.id}>
                  <a
                    href={`#${l.id}`}
                    onClick={(e) => {
                      e.preventDefault();
                      document.getElementById(l.id)?.scrollIntoView({ behavior: "smooth" });
                    }}
                    className="inline-flex items-center gap-2 text-sm text-secondary-800 transition hover:text-primary-700"
                  >
                    <i className="ri-arrow-right-up-line text-secondary-600"></i>
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* 联系 */}
          <div>
            <h4 className="font-heading text-base font-bold text-secondary-950">联系与合作</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-secondary-800">
              <li className="flex items-center gap-2">
                <i className="ri-mail-send-line text-primary-600"></i>
                <a href="mailto:hello@chiguatoutiao.cn" className="hover:text-primary-700">
                  hello@chiguatoutiao.cn
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-primary-600"></i>
                全天候滚动更新
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-primary-600"></i>
                内容编辑部 · 全网
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-secondary-200 pt-6">
          <div className="flex flex-col gap-2 text-xs leading-relaxed text-secondary-700">
            <p>
              免责声明：本站内容为娱乐资讯整理与内容聚合，涉及具体人物与事件的报道均为基于公开素材的虚构演绎与观察评论，不指向任何真实个人，仅供阅读与讨论。
            </p>
          </div>
          <div className="mt-4 flex flex-col items-center justify-between gap-3 sm:flex-row">
            <p className="text-xs text-secondary-700">
              © 2026 {siteName} 版权所有 · 吃瓜就要吃最新最猛的
            </p>
            <div className="flex items-center gap-4 text-xs text-secondary-700">
              <a href="#top" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: "smooth" }); }} className="inline-flex items-center gap-1 hover:text-primary-700">
                <i className="ri-arrow-up-line"></i>回到顶部
              </a>
              <span className="inline-flex items-center gap-1">
                <i className="ri-shield-check-line"></i>理性吃瓜
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}